const AUTH_TOKEN_KEY = "authLisualToken"; // Actualizado a la clave correcta

export const decodeJwtPayload = (token) => {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    return JSON.parse(atob(padded));
  } catch (_) {
    return null;
  }
};

export const getAuthClaims = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const payload = decodeJwtPayload(token);

  return {
    token,
    role: payload?.role || null,
    customerId: payload?.customerId ? String(payload.customerId) : null,
    userId: payload?.id || payload?.sub || null,
    raw: payload,
  };
};

export const getCustomerDashboardPathFromToken = () => {
  const { customerId, role } = getAuthClaims();
  if (!customerId) return null;
  if (role === "guest") return null;
  return `/customerDashboard/${customerId}`;
};
